import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import BtnComponent from '../buttonComponent/BtnComponent';
import SecondaryBtnComponent from '../buttonComponent/SecondaryBtnComponent';
import { Grid } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import EventIcon from '@mui/icons-material/Event';
import { useSnackbar } from 'notistack';
import { useLazyQuery } from '@apollo/client';
import { FETCH_APPOINTMENT_BY_ID } from '../../services/AppointmentQueries/AppointmentService';
import avataricon from '../../assests/avataricon.svg';
import { useNavigate } from 'react-router-dom';
import { APPOINTMENTS } from '../../shared/Strings';

function UpcomingVirtualVisitCard(props) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [fetchAppointmentById, fetchAppointmentByIdCall] = useLazyQuery(
    FETCH_APPOINTMENT_BY_ID,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(APPOINTMENTS.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        // console.log(res);
        navigate(`/care/appointments`, {
          state: {
            id: props.cardData.id,
          },
        });
      },
    }
  );
  const viewDetails = () => {
    fetchAppointmentById({
      variables: {
        apptId: props.cardData.id,
      },
    });
  };
  return (
    <div>
      <Card sx={{ width: '340px', height: '176px', borderRadius: ' 8px' }}>
        <CardContent>
          <Typography
            sx={{ fontSize: 16, fontWeight: 500, lineHeight: '24px' }}
            gutterBottom>
            {props.cardData.title}
          </Typography>

          <Grid container spacing={2}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <EventIcon sx={{ fontSize: 20 }}></EventIcon>
              <Typography
                sx={{
                  lineHeight: '16px',
                  fontSize: 12,
                  marginLeft: '8px',
                }}>
                {' '}
                {props.cardData.date}
              </Typography>
            </Grid>

            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <AccessAlarmsIcon sx={{ fontSize: 20 }}></AccessAlarmsIcon>
              <Typography
                sx={{
                  lineHeight: '16px',
                  fontSize: 12,
                  marginLeft: '8px',
                }}>
                {' '}
                {props.cardData.time}
              </Typography>
            </Grid>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <Avatar
                src={props.cardData.avatarLink || avataricon}
                sx={{ width: 16, height: 16 }}
              />
              <Typography
                sx={{
                  lineHeight: '16px',
                  fontSize: 12,
                  marginLeft: '8px',
                }}>
                {' '}
                {props.cardData.avatarName}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
          }}>
          <SecondaryBtnComponent
            title={props.cardData.secondaryBtnTitle}
            onClick={viewDetails}
            sx={{
              width: ' 150px',
              height: ' 40px',
              padding: ' 8px 24px',
              fontSize: '16px',
            }}
          />
          <BtnComponent
            title={props.cardData.primaryBtnTitle}
            disabled
            sx={{
              width: ' 150px',
              height: ' 40px',
              fontSize: '16px',
              padding: ' 8px 24px',
            }}
          />
        </CardActions>
      </Card>
    </div>
  );
}

export default UpcomingVirtualVisitCard;
